import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useDirectDealsPublisherDetails } from '../../../utils/context/DirectDealsPublisherDetailsContext.tsx';

type DemographicInfoCardProps = {
  title: string;
};

export const DemographicInfoCard = ({ title }: DemographicInfoCardProps) => {
  const publisherDetails = useDirectDealsPublisherDetails();

  if (!publisherDetails?.demographic_info || publisherDetails.demographic_info.length === 0) {
    return null;
  }

  return (
    <Box
      data-test="demographic-info"
      sx={{
        border: 1,
        padding: 3,
        borderColor: 'divider',
        marginTop: 4,
      }}
    >
      <Box
        sx={{
          paddingBottom: 1,
          borderBottom: 1,
          marginBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Typography variant="h3">{title}</Typography>
      </Box>
      <Typography
        variant="body1"
        sx={{
          marginTop: 1,
        }}
      >
        {publisherDetails.demographic_info}
      </Typography>
    </Box>
  );
};
